import { Theme, useMediaQuery } from '@mui/material'

const useIsDesktop = () => useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))

export default useIsDesktop
